import { render } from "./RateCard.vue?vue&type=template&id=7079bf86"
import script from "./RateCard.vue?vue&type=script&lang=js"
export * from "./RateCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__